import React from 'react'
import PropTypes from 'prop-types'
import SummitOnlyContent from '../../../atoms/SummitOnlyContent'
import CodeBlock from '../../../atoms/CodeBlock'
import { usePipelineDataContextWithVariables } from '../provider/DDPDataProvider'
import Loading from '../../../molecules/Loading'
import ErrorDisplay from '../../../molecules/ErrorDisplay'

function DDPDebug ({ pipeline, variables, scroll }) {
  const { data, isLoading, error } = usePipelineDataContextWithVariables(pipeline, variables)

  return (
    <SummitOnlyContent>
      {isLoading ? (
        <Loading />
      ) : error ? (
        <ErrorDisplay error={error} />
      ) : (
        <CodeBlock code={data} scroll={scroll} />
      )}
    </SummitOnlyContent>
  )
}

DDPDebug.propTypes = {
  /** The data pipeline to execute */
  pipeline: PropTypes.oneOfType([PropTypes.array, PropTypes.string]),

  variables: PropTypes.any,
  scroll: PropTypes.bool
}

export default DDPDebug
